import { apiClient, type Paginated } from '@/core/api';
import type {
  Assessment,
  AssessmentAttempt,
  AssessmentAttemptInput,
  AssessmentInput,
} from './types';

export const BASE = '/lms/assessments/';
const ATTEMPTS = '/lms/assessment-attempts/';

export interface AssessmentListParams {
  page?: number;
  search?: string;
  course?: number;
  is_active?: boolean;
  /** DRF `OrderingFilter` value, e.g. `title` or `-created`. */
  ordering?: string;
}

export async function listAssessments(
  params: AssessmentListParams = {},
): Promise<Paginated<Assessment>> {
  const { data } = await apiClient.get<Paginated<Assessment>>(BASE, { params });
  return data;
}

export async function createAssessment(input: AssessmentInput): Promise<Assessment> {
  const { data } = await apiClient.post<Assessment>(BASE, input);
  return data;
}

export async function updateAssessment(
  id: number,
  input: Partial<AssessmentInput>,
): Promise<Assessment> {
  const { data } = await apiClient.patch<Assessment>(`${BASE}${id}/`, input);
  return data;
}

export async function deleteAssessment(id: number): Promise<void> {
  await apiClient.delete(`${BASE}${id}/`);
}

export interface AttemptListParams {
  page?: number;
  assessment?: number;
  user?: number;
  passed?: boolean;
}

export async function listAttempts(
  params: AttemptListParams = {},
): Promise<Paginated<AssessmentAttempt>> {
  const { data } = await apiClient.get<Paginated<AssessmentAttempt>>(ATTEMPTS, { params });
  return data;
}

/** Record an attempt; the server decides pass/fail against `passing_score`. */
export async function createAttempt(input: AssessmentAttemptInput): Promise<AssessmentAttempt> {
  const { data } = await apiClient.post<AssessmentAttempt>(ATTEMPTS, input);
  return data;
}
